import { formatterPrice } from 'src/utils/formatterPrice'
import { useState } from 'react'
import classNames from 'classnames'
import { useModalSheet } from 'src/components/contexts/ModalSheetContext'

import { useKitlook } from '../context/KitlookContext'
import { KitlookCarousel } from './KitlookCarousel'
import KitlookDetailsModal from './shared/KitlookDetailsModal'
import { KitlookItemsConfirmation } from './KitlookItemsConfirmation'

export interface KitlookResumeOverrides {
  image?: string
  title?: string
  buttonText?: string
}

interface KitlookWidgetResumeProps {
  overrides?: KitlookResumeOverrides
  hideKitInfo?: boolean
}

export function KitlookWidgetResume({
  overrides,
  hideKitInfo = false,
}: KitlookWidgetResumeProps) {
  const { currentKit } = useKitlook()

  const [isOpenKitlookDetailsModal, setIsOpenKitlookDetailsModal] =
    useState(false)

  const { openModal, closeModal } = useModalSheet()

  const openKitlookItemsModal = () => {
    openModal({
      content: (
        <KitlookItemsConfirmation
          currentKit={currentKit}
          closeModal={closeModal}
        />
      ),
      width: '360px',
    })
  }

  if (!currentKit) return null

  const backgroundImage = overrides?.image ?? currentKit.image
  const buttonLabel = overrides?.buttonText ?? 'Levar Kit completo'
  const isCMSCollection = Boolean(
    overrides?.title ?? overrides?.buttonText ?? overrides?.image
  )

  return (
    <div
      className={classNames(
        'max-w-[450px] w-full min-w-0 h-full flex items-end overflow-visible bg-cover bg-no-repeat bg-center',
        {
          'md:w-[450px] md:shrink-0': !isCMSCollection,
          'min-h-[350px] md:min-h-[500px]': isCMSCollection,
          'min-h-[624px] md:min-h-[486px]': !isCMSCollection,
        }
      )}
      style={{
        backgroundImage: `url(${backgroundImage})`,
      }}
    >
      <div
        className={classNames(
          'w-full min-w-0 h-full min-h-[191px] py-8 px-6 md:px-11 overflow-visible',
          {
            'flex flex-col justify-end gap-[18px] bg-[linear-gradient(0deg,rgba(0,0,0,0.7)_34.96%,rgba(0,0,0,0)_100%,rgba(0,0,0,0)_100%)]':
              isCMSCollection,
            'bg-[linear-gradient(180deg,rgba(27,23,23,0)_0%,#1B1717_46.63%)]':
              !isCMSCollection,
          }
        )}
      >
        <p
          className={classNames('font-semibold text-sm text-white', {
            'text-center mt-auto': isCMSCollection,
          })}
        >
          {overrides?.title ?? 'Leve este kit inteiro por'}
        </p>

        {!hideKitInfo && (
          <div className="flex items-center gap-1">
            <span className="text-white font-bold text-[32px]">
              {formatterPrice(currentKit.sellerDefault.sellerOffer.price)}
            </span>
            {currentKit.sellerDefault.sellerOffer.hasDiscount && (
              <span className="bg-redDiscount py-[2px] px-1 text-sm line-through text-white font-semibold">
                {formatterPrice(currentKit.sellerDefault.sellerOffer.listPrice)}
              </span>
            )}
          </div>
        )}

        {!hideKitInfo && (
          <div className="md:hidden w-[calc(100%+2.5rem)] -mr-10">
            <KitlookCarousel />
          </div>
        )}
        <button
          onClick={() => openKitlookItemsModal()}
          className={classNames(
            'flex-1 w-full box-border py-3 h-12 rounded-round font-medium',
            {
              'grow-0 font-semibold bg-white text-[13px] md:text-lg text-mainPrice':
                isCMSCollection,
              'px-xxs text-base bg-restructure-background-action-1 hover:bg-restructure-background-action-1-hover text-restructure-primary-inverted':
                !isCMSCollection,
            }
          )}
        >
          {buttonLabel}
        </button>
        {!hideKitInfo && (
          <button
            type="button"
            onClick={() => setIsOpenKitlookDetailsModal(true)}
            className="block md:hidden mt-4 mx-auto bg-transparent border-none text-white font-bold text-sm text-center"
          >
            Mais detalhes do kit
          </button>
        )}

        {isOpenKitlookDetailsModal && (
          <KitlookDetailsModal
            setIsKitlookModalOpen={setIsOpenKitlookDetailsModal}
          />
        )}
      </div>
    </div>
  )
}
